module.exports = __webpack_public_path__ + "img/turkiye-is-bankasi-isbox-kinect-02.ae201aeb.jpg";